import type { Point2d, Rectangle2d } from ".."

export const pointsToBox = (
  p1: Point2d,
  p2: Point2d,
): Rectangle2d & { quadrant: 1 | 2 | 3 | 4 } => {
  const x = Math.min(p2.x, p1.x)
  const y = Math.min(p2.y, p1.y)
  const w = Math.abs(p2.x - p1.x)
  const h = Math.abs(p2.y - p1.y)
  /* eslint-disable */
  const quadrant = p2.x > p1.x ? (p2.y > p1.y ? 1 : 4) : p2.y > p1.y ? 2 : 3
  /* eslint-enable */

  return { x, y, w, h, r: 0, quadrant }
}
